import { Fragment, useEffect, useState } from "react";
import { GetCampaign } from "../../../Services";
import { toast } from "react-toastify";
import ModalDialog from "../../../components/modalDialog/ModalDialog";
import ModalDialogContent from "../../../components/modalDialog/modalDialogContent/ModalDialogContent";
import ModalDialogButtons from "../../../components/modalDialog/modalDialogButtons/ModalDialogButtons";
import Spinner from "../../../components/spinner/Spinner";
import GbpPostingForm from "./GbpPostingForm";

const GbpPostingDialog = ({ campaignId, onClose, onSubmit }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [campaign, setCampaign] = useState();

    useEffect(() => {
        if (campaignId) {
            getCampaign();
        }
    }, [campaignId]);

    const getCampaign = async () => {
        setIsLoading(true);

        const response = await GetCampaign(campaignId);

        if (response) {
            setCampaign(response);
        }

        setIsLoading(false);
    };

    const handleSubmit = () => {
        if (onSubmit) {
            onSubmit();
        }
    };

    const handleCloseDialog = () => {
        if (onClose) {
            onClose();
        }
    };

    useEffect(() => {
        document.addEventListener("visibilitychange", handleTabFocus);

        // Specify how to clean up after this effect:
        return () => {
            document.removeEventListener("visibilitychange", handleTabFocus);
        };
    }, []);

    // User has switched back to the tab
    const handleTabFocus = () => {
        if (document.visibilityState === "visible") {
            getCampaign();
        }
    };

    return (
        <Fragment>
            <ModalDialog position="right-sidebar" className="text-start">
                <ModalDialogContent align="start">
                    {/* {isLoading && <Spinner></Spinner>} */}

                    {campaign && <GbpPostingForm campaignData={campaign} onSubmit={handleSubmit} isLoading={isLoading}></GbpPostingForm>}
                </ModalDialogContent>
                <ModalDialogButtons>
                    <button className="btn btn-outline-primary" type="button" onClick={handleCloseDialog}>
                        Cancel
                    </button>
                </ModalDialogButtons>
            </ModalDialog>
        </Fragment>
    );
};

export default GbpPostingDialog;
